<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" :title="!dataForm.id ? '新增' : '编辑'" width="680px" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="150px" v-loading="dialogLoading">
      <!-- <el-form-item prop="companyId" label="公司">
        <el-select style="width: 100%;" v-model="dataForm.companyId" @change="handleCompanyChange" placeholder="请选择公司" filterable autocomplete="off" clearable>
          <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item prop="projectId" label="项目">
        <el-select style="width: 100%;" v-model="dataForm.projectId"  placeholder="请选择项目" filterable autocomplete="off" clearable>
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName" :value="item.projectId" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="workBaseId" label="基地站">
        <el-select style="width: 100%;" v-model="dataForm.workBaseId"  placeholder="请选择基地站" filterable autocomplete="off" clearable>
          <el-option v-for="item in workBaseList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'addOrUpdate',
  props: {
    companyList: Array
  },
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      size: 'small',
      dialogLoading: false,
      visible: false,
      serversList: [],
      clientServersList: [],
      dataForm: {
        projectId: '',
        workBaseId: '',
        companyId: 0
      },
      workBaseList: [],
      projectList: []
    }
  },
  computed: {
    dataRule () {
      return {
        projectId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        workBaseId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (row) {
      this.visible = true
      this.dataForm = {
        projectId: '',
        workBaseId: '',
        companyId: 0
      }
      this.$api.electricOperations.listElectricOperationsWorkBases(0).then(res => {
        if (res.success) {
          this.workBaseList = res.data
        }
      })
      this.$api.contract.getContractProjectByContractId({
        companyId: 0,
        contactId: []
      }).then((res) => {
        if (res.success) {
          this.projectList = res.data
        }
      })
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (row !== null) {
          this.dataForm = Object.assign({}, row)
        }
      })
    },
    handleCompanyChange (val) {
      this.projectList = []
      this.$api.contract.getContractProjectByContractId({
        companyId: val,
        contactId: []
      }).then((res) => {
        if (res.success) {
          this.projectList = res.data
        }
      })
    },
    submitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        if (this.dataForm.id) {
          this.$api.electricOperations.setElectricOperationsWorkOrderDispatchingPriorityRegulation({ ...this.dataForm }).then((res) => {
            this.dialogLoading = false
            if (res.success) {
              this.$message.success('操作成功')
              this.visible = false
              this.$emit('handleQuery')
            }
          })
        } else {
          this.$api.electricOperations.setElectricOperationsWorkOrderDispatchingPriorityRegulation({ ...this.dataForm }).then((res) => {
            this.dialogLoading = false
            if (res.success) {
              this.$message.success('操作成功')
              this.visible = false
              this.$emit('handleQuery')
            }
          })
        }
      })
    }, 1000, { 'leading': true, 'trailing': false }) 
  }
}
</script>

<style lang="scss" scoped>
.dialog-simple {
  text-align: left;
}
</style>
